import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(".category-nav ul li").eq(0).addClass("active");
$(".section1 .content .container").eq(0).addClass("active");
$(".category-nav ul li").click(function() {
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(".section1 .content .container").eq(index).addClass('active').siblings().removeClass('active');
})
var swiper = new Swiper(".section2 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
         spaceBetween: 10,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper = new Swiper(".section4 .mySwiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.82%',
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});